import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router";
import { ApiErrorHandler } from "./components/Notify";
import { AuthProvider } from "./context/AuthContext";
import { LoadingOverlay } from "./layouts/components";
import { getRouter } from "./router";
import "./styles/index.styl";
// gravity-ui config
import { settings as settingsGravityDate } from "@gravity-ui/date-utils";
import { configure as configGravityUI, ThemeProvider, Toaster, ToasterComponent, ToasterProvider, } from "@gravity-ui/uikit";
import { store } from "./store/store";
configGravityUI({
    lang: "ru",
});
settingsGravityDate.loadLocale("ru").then(function () {
    settingsGravityDate.setLocale("ru");
});
/**
 * Компонент приложения
 */
var App = function () {
    var toaster = new Toaster();
    return (_jsx(Provider, { store: store, children: _jsx(AuthProvider, { children: _jsx(ThemeProvider, { theme: "light", children: _jsx(ToasterProvider, { toaster: toaster, children: _jsxs(ApiErrorHandler, { children: [_jsx(RouterProvider, { router: getRouter() }), _jsx(LoadingOverlay, {}), _jsx(ToasterComponent, {})] }) }) }) }) }));
};
/** Рендер приложения */
export var bootApp = function () {
    var rootNode = document.getElementById("root");
    var root = createRoot(rootNode);
    root.render(_jsx(React.StrictMode, { children: _jsx(App, {}) }));
};
